import React, { Suspense, useEffect, useRef, useState } from 'react';
import { sectionRegistry } from './sectionRegistry';

const SectionFallback = () => (
  <div className="min-h-[180px]" aria-hidden="true" />
);

const SectionRenderer = ({ sectionKey }) => {
  const SectionComponent = sectionRegistry[sectionKey];
  const containerRef = useRef(null);
  const [shouldRender, setShouldRender] = useState(sectionKey === 'hero');

  useEffect(() => {
    if (shouldRender || sectionKey === 'hero') {
      return undefined;
    }

    const element = containerRef.current;
    if (!element) {
      setShouldRender(true);
      return undefined;
    }

    if (!('IntersectionObserver' in window)) {
      setShouldRender(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShouldRender(true);
          observer.disconnect();
        }
      },
      { rootMargin: '900px 0px' }
    );

    observer.observe(element);

    return () => observer.disconnect();
  }, [sectionKey, shouldRender]);

  if (!SectionComponent) {
    return null;
  }

  if (!shouldRender) {
    return <div ref={containerRef}><SectionFallback /></div>;
  }

  return (
    <div ref={containerRef}>
      <Suspense fallback={<SectionFallback />}>
        <SectionComponent />
      </Suspense>
    </div>
  );
};

export default SectionRenderer;
